'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TitleContainer = undefined;

var _Style = require('./Style');

var _Style2 = _interopRequireDefault(_Style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TitleContainer = function TitleContainer(refs) {
    var i18n = refs.i18nManager.get();

    var container = Ext.create('Ext.container.Container', {
        layout: 'column',
        style: 'margin-bottom:1px',
        bodyStyle: 'border:0 none'
    });

    container.hideTitleCheckbox = Ext.create('Ext.form.field.Checkbox', {
        boxLabel: i18n.hide_chart_title,
        style: 'margin-bottom:' + _Style2.default.checkboxBottomMargin + 'px; margin-right: 5px',
        width: 125,
        listeners: {
            change: function change() {
                container.titleInput.xable();
            }
        }
    });

    container.titleInput = Ext.create('Ext.form.field.Text', {
        width: _Style2.default.cmpWidth - _Style2.default.labelWidth - 5,
        emptyText: i18n.chart_title,
        maxLength: 100,
        enforceMaxLength: true,
        style: 'margin-bottom:0',
        xable: function xable() {
            this.setDisabled(container.hideTitleCheckbox.getValue());
        }
    });

    container.add([container.hideTitleCheckbox, container.titleInput]);

    return container;
};

exports.TitleContainer = TitleContainer;
exports.default = TitleContainer;
//# sourceMappingURL=Title.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/options/Title.js
 ** module id = 363
 ** module chunks = 0
 **/